import React from 'react'
import { useLocation } from 'react-router'

import { ErrorView } from 'redesign/components/organisms/ErrorView'
import { ErrorStateView } from 'redesign/typings/errorStateView'

export const FullError = () => {
    const location = useLocation<ErrorStateView>()
    return <ErrorView content={location.state} />
}
